import React, { useEffect, useState } from "react";
import "./App.css";
import Video from "./Video";

function App() {
  const [video, setVideo] = useState([]);
  useEffect(() => {
    const fetchVideo = async () =>
      await fetch("https://jack-tiktok.herokuapp.com/v2/posts")
        .then((res) => res.json())
        .then((data) => {
          setVideo(data.map((e) => e));
        })
        .catch((e) => console.log("error ==>>>>", e));
    fetchVideo();
  }, []);

  return (
    <div className="app">
      <div className="app_videos">
        {video?.map(
          ({
            url,
            channel,
            song,
            description,
            likes,
            messages,
            shares,
            _id,
          }) => {
            return (
              <Video
                key={_id}
                url={"/video/" + url + ".mp4"}
                description={description}
                channel={channel}
                song={song}
                likes={likes}
                messages={messages}
                share={shares}
              />
            );
          }
        )}
      </div>
    </div>
  );
}

export default App;
